import { render, staticRenderFns } from "./ProfileSummary.vue?vue&type=template&id=4574c5c0&scoped=true&"
import script from "./ProfileSummary.vue?vue&type=script&lang=js&"
export * from "./ProfileSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4574c5c0",
  null
  
)

export default component.exports